var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 98.179,
    viewBox: "0 0 101 98.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19946",
    "data-name": "Group 19946",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24106",
    "data-name": "Path 24106",
    d: "M164.043,62.936h-3.329a.9.9,0,0,0,0,1.8h3.329a.9.9,0,0,0,0-1.8Z",
    transform: "translate(-127.504 -56.249)",
    fill: "#005795",
    stroke: "#005795",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24107",
    "data-name": "Path 24107",
    d: "M230.349,64.736h12.932a.9.9,0,1,0,0-1.8H230.349a.9.9,0,0,0,0,1.8Z",
    transform: "translate(-179.188 -56.249)",
    fill: "#005795",
    stroke: "#005795",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24108",
    "data-name": "Path 24108",
    d: "M164.043,105.989h-3.329a.9.9,0,1,0,0,1.8h3.329a.9.9,0,1,0,0-1.8Z",
    transform: "translate(-127.504 -86.467)",
    fill: "#005795",
    stroke: "#005795",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24109",
    "data-name": "Path 24109",
    d: "M230.349,107.789h12.932a.9.9,0,1,0,0-1.8H230.349a.9.9,0,1,0,0,1.8Z",
    transform: "translate(-179.188 -86.467)",
    fill: "#005795",
    stroke: "#005795",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24110",
    "data-name": "Path 24110",
    d: "M164.043,149.043h-3.329a.9.9,0,1,0,0,1.8h3.329a.9.9,0,0,0,0-1.8Z",
    transform: "translate(-127.504 -121.012)",
    fill: "#005795",
    stroke: "#005795",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24111",
    "data-name": "Path 24111",
    d: "M230.349,150.843h12.932a.9.9,0,1,0,0-1.8H230.349a.9.9,0,0,0,0,1.8Z",
    transform: "translate(-179.188 -121.012)",
    fill: "#005795",
    stroke: "#005795",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24112",
    "data-name": "Path 24112",
    d: "M181.136,371.006v-4.4a1.558,1.558,0,0,0-1.557-1.557H159.043a1.558,1.558,0,0,0-1.556,1.557v4.4a1.558,1.558,0,0,0,1.556,1.557h20.536A1.558,1.558,0,0,0,181.136,371.006Zm-1.8-.244H159.287v-3.912h20.048Z",
    transform: "translate(-119.312 -291.284)",
    fill: "#005795",
    stroke: "#005795",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24113",
    "data-name": "Path 24113",
    d: "M164.043,192.1h-3.329a.9.9,0,1,0,0,1.8h3.329a.9.9,0,1,0,0-1.8Z",
    transform: "translate(-127.504 -155.555)",
    fill: "#005795",
    stroke: "#005795",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24114",
    "data-name": "Path 24114",
    d: "M230.349,193.9h12.932a.9.9,0,1,0,0-1.8H230.349a.9.9,0,0,0,0,1.8Z",
    transform: "translate(-179.188 -155.555)",
    fill: "#005795",
    stroke: "#005795",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24115",
    "data-name": "Path 24115",
    d: "M164.043,235.149h-3.329a.9.9,0,0,0,0,1.8h3.329a.9.9,0,1,0,0-1.8Z",
    transform: "translate(-127.504 -190.099)",
    fill: "#005795",
    stroke: "#005795",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24116",
    "data-name": "Path 24116",
    d: "M230.349,236.949h12.932a.9.9,0,1,0,0-1.8H230.349a.9.9,0,0,0,0,1.8Z",
    transform: "translate(-179.188 -190.099)",
    fill: "#005795",
    stroke: "#005795",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24117",
    "data-name": "Path 24117",
    d: "M192.529,451.807a.9.9,0,1,0,0,1.8h13.652a.9.9,0,1,0,0-1.8Z",
    transform: "translate(-149.356 -360.986)",
    fill: "#005795",
    stroke: "#005795",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24118",
    "data-name": "Path 24118",
    d: "M98.535,62.124H92.284L96.045,36.66a1.465,1.465,0,0,0-2.9-.428L89.322,62.124H76.986V16.5l18.258,2.94a.377.377,0,0,1,.25.154.392.392,0,0,1,.065.305L94.019,30.326a1.465,1.465,0,1,0,2.9.428l1.538-10.412a3.314,3.314,0,0,0-2.745-3.8L76.986,13.528V10.536a3.318,3.318,0,0,0-3.314-3.314H48.1a1.465,1.465,0,1,0,0,2.93H73.672a.385.385,0,0,1,.385.385V62.124H66.29a4.475,4.475,0,0,0-4.174,2.9l-1.453,3.89a1.533,1.533,0,0,1-1.429.992H40.766a1.533,1.533,0,0,1-1.429-.992l-1.453-3.89a4.475,4.475,0,0,0-4.174-2.9H25.943V10.536a.385.385,0,0,1,.385-.385H42.247a1.465,1.465,0,1,0,0-2.93H26.328a3.318,3.318,0,0,0-3.314,3.314v2.992L4.291,16.543a3.314,3.314,0,0,0-2.748,3.78l6.174,41.8H1.465A1.465,1.465,0,0,0,0,63.589V90.644A13.772,13.772,0,0,0,13.756,104.4H20.1a1.465,1.465,0,1,0,0-2.93H13.756A10.839,10.839,0,0,1,2.93,90.645V65.054H33.71a1.532,1.532,0,0,1,1.429.992l1.453,3.89a4.476,4.476,0,0,0,4.174,2.9H59.234a4.475,4.475,0,0,0,4.174-2.9l1.453-3.89a1.533,1.533,0,0,1,1.429-.992H97.07V90.644a10.839,10.839,0,0,1-10.827,10.827H25.96a1.465,1.465,0,1,0,0,2.93H86.244A13.772,13.772,0,0,0,100,90.644V63.589A1.465,1.465,0,0,0,98.535,62.124ZM4.438,19.876a.385.385,0,0,1,.319-.441L23.014,16.5V62.124H10.677Z",
    transform: "translate(0 -7.222)",
    fill: "#005795",
    stroke: "#005795",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectMaster);
export default __webpack_public_path__ + "static/media/projectMaster.5e8e5f35367211b8712615c444ac78a3.svg";
export { ForwardRef as ReactComponent };